export const locationToAbsoluteURL = ({ pathname = '', search = '', hash = '' }) =>
  `${window.location.origin}${pathname}${search}${hash}`;
